module.exports = {
      id: "ic-ichimoku-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-ichimoku-usage",
      toString: function () {
        return this.url;
      }
    }